// Een brief-sjabloon (LetterTemplates) invullen voor de printpagina.
//
// Alinea's worden gescheiden door een lege regel; binnen een alinea is elke
// regel een eigen regel op papier. Invulplekken: {{organisatie}},
// {{onderzoek}}, {{meetmoment}}. Een plek zonder waarde wordt leeg: een
// letterlijke {{...}} hoort nooit op een brief die een bewoner krijgt.
// AI-CONTEXT: See docs/features/adres-koppeling-algemene-qr.md

const PLACEHOLDER = /\{\{\s*([a-zA-Z]+)\s*\}\}/g

/**
 * @param {string} text
 * @param {Record<string, string>} values - Sleutels in kleine letters
 * @returns {string}
 */
const fill = (text, values) =>
    String(text || '').replace(PLACEHOLDER, (_m, key) => String(values[key.toLowerCase()] ?? ''))

/**
 * @param {{Title?: string, Body?: string}|undefined} template
 * @param {Record<string, string>} values
 * @returns {{title: string, paragraphs: string[][]}}
 */
const fillLetterTemplate = (template, values) => {
    if (!template) return { title: '', paragraphs: [] }
    const body = fill(template.Body, values).replace(/\r\n/g, '\n')
    const paragraphs = body
        .split(/\n\s*\n/)
        .map((block) => block.split('\n').map((line) => line.trim()).filter(Boolean))
        .filter((lines) => lines.length > 0)
    return { title: fill(template.Title, values), paragraphs }
}

export default fillLetterTemplate
